/**
 * Time-bucketing intervals for chart / report time-series queries.
 *
 * Pure data (no Angular / browser deps) so it can be shared by the Angular-free
 * chart core, the pure config parser (`parseChartSource` in `custom-chart.ts`),
 * and the Angular layer alike. `utils.ts` re-exports every symbol here, so the
 * ~26 files that import these from `../utils` keep working unchanged.
 */

export class TimeInterval {
  intervalName: string;
  apiParam: string;
  singleIntervalTerm: string;
}

export const TimeIntervalDaily: TimeInterval = {
  intervalName: 'Daily',
  apiParam: 'daily',
  singleIntervalTerm: 'Date'
};
export const TimeIntervalWeekly: TimeInterval = {
  intervalName: 'Weekly',
  apiParam: 'weekly',
  singleIntervalTerm: 'Week'
};
export const TimeIntervalMonthly: TimeInterval = {
  intervalName: 'Monthly',
  apiParam: 'monthly',
  singleIntervalTerm: 'Month'
};
export const TimeIntervals: TimeInterval[] = [
  TimeIntervalDaily,
  TimeIntervalWeekly,
  TimeIntervalMonthly,
  {
    intervalName: 'Quarterly',
    apiParam: 'quarterly',
    singleIntervalTerm: 'Quarter'
  },
  {
    intervalName: 'Annual',
    apiParam: 'annual',
    singleIntervalTerm: 'Year'
  },
];

/**
 * Normalize an arbitrary interval value to a known interval's `apiParam`,
 * falling back to daily for an absent or unrecognized value. The single home for
 * the "unknown interval → daily" rule, so every consumer of a saved chart config
 * (the browser builder, the embedded view, a future Node renderer) treats a bad
 * interval identically instead of forwarding junk to the metrics API.
 */
export function normalizeIntervalApiParam(value: any): string {
  const match = TimeIntervals.find(interval => interval.apiParam === value);
  return match ? match.apiParam : TimeIntervalDaily.apiParam;
}
